import FeatherIcon from "feather-icons-react";
import ActivityLogComponent from "@screens/dashboard/components/activity-log.component";
import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";

const DashboardTemplateComponent = ({ templateModal: { dashboardData } }) => {
  return (
    <PageWrapperComponent>
      <div className="app-user-list">
        <div className="row">
          <div className="col-sm-6 col-lg-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3 className="fw-bolder mb-75">
                      {dashboardData?.totalUsers}
                    </h3>
                    <p className="card-text">Total Users</p>
                  </div>
                  <div className="avatar avatar-stats p-50 m-0 bg-light-primary">
                    <div className="avatar-content">
                      <FeatherIcon icon="users" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3 className="fw-bolder mb-75">
                      {dashboardData?.totalUserLog}
                    </h3>
                    <p className="card-text">Total Logs</p>
                  </div>
                  <div className="avatar avatar-stats p-50 m-0 bg-light-success">
                    <div className="avatar-content">
                      <FeatherIcon icon="file" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3 className="fw-bolder mb-75">
                      {dashboardData?.totalEmailTemplate}
                    </h3>
                    <p className="card-text">Email Template</p>
                  </div>
                  <div className="avatar avatar-stats p-50 m-0 bg-light-info">
                    <div className="avatar-content">
                      <FeatherIcon icon="mail" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3 className="fw-bolder mb-75">
                      {dashboardData?.totalBlockedIp}
                    </h3>
                    <p className="card-text">Blocked IP</p>
                  </div>
                  <div className="avatar avatar-stats p-50 m-0 bg-light-danger">
                    <div className="avatar-content">
                      <FeatherIcon icon="minus-circle" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ActivityLogComponent
        activities={dashboardData?.recentLog}
        title="Activity Log"
      />
    </PageWrapperComponent>
  );
};

export default DashboardTemplateComponent;
